import { httpClient } from '../http/httpClient'

export interface GetPublicUserResponse {
  _id: string
  name: string
  phone: string
  profileImageUrl: string
}

export async function getPublicUser(linkName: string) {
  const { data } = await httpClient.get<GetPublicUserResponse>(
    `/self-hire/user/${linkName}`,
  )

  return data
}
